import { __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { LoadingState } from '@cheetahdigital/console-kit-cx';
import { createPortal } from 'react-dom';
import styles from './index.module.scss.js';

var Loading = function (_a) {
    var _b = _a.size, size = _b === void 0 ? "medium" : _b, spinnerSize = _a.spinnerSize, label = _a.label, isPageLoading = _a.isPageLoading;
    var Loading = function () { return (jsx(LoadingState, { header: label, height: size, spinnerSize: spinnerSize || size }, void 0)); };
    return (jsxs(Fragment, { children: [!isPageLoading && jsx(Loading, {}, void 0), isPageLoading &&
                createPortal(jsx("div", __assign({ className: styles.isPageLoading }, { children: jsx(Loading, {}, void 0) }), void 0), document.body)] }, void 0));
};

export { Loading as default };
